export default __webpack_public_path__ + "static/media/mercury-large.c8f5c18a.png";